export default {
  Auth: {
    mandatorySignIn: true,
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
  },
  
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_S3_IMAGE_BUCKET_REGION,
      region: process.env.REACT_APP_S3_REGION
    }
  },

  API: {
    endpoints: [
      {
        name: 'bridge',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'account',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'calendar',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'billing',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'external-sync',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'rundown',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'bookings',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'group-bookings',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'group-manage',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'organization',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'schedules',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'scan',
        endpoint: process.env.REACT_APP_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
      {
        name: 'contactSearch',
        endpoint: process.env.REACT_APP_SEARCH_API_URL,
        region: process.env.REACT_APP_API_REGION,
      },
    ],
  },
}
